import React from "react";

function OracleDBA_L1() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle DBA – L1 </h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/OracleDBA_L1.jpg")}
              alt=""
            />
          </div>
          <div className="heading">
            <h1>Oracle DBA – L1</h1>

            <h3>Course Description –</h3>

            <h4>Introduction Oracle DBA </h4>
            <ul>
              <li>Describe course objectives</li>
              <li>
                Explore the Oracle DBA (Oracle 11g & 12C database architecture)
              </li>
            </ul>
            <h4>Installing the Oracle Database Software</h4>
            <ul>
                <li> Explain core Oracle DBA tasks and tools</li>
                <li> </li>
                <li>Plan an Oracle DBA installation</li>
                <li>Use optimal flexible architecture</li>
                <li>Install software with the Oracle Universal Installer (OUI)</li>
            </ul>

            <h4>Creating an Oracle Database</h4>
            <ul>
                <li>Create a database with the Database Configuration Assistant (DBCA)</li>
            <li>Create a database design template with the DBCA </li>
            <li>Generate database creation scripts with the DBCA </li>
            </ul>

            <h4>
            Managing the Oracle Instance 
            </h4>
            <ul>
                <li>Start and stop the Oracle database and components </li>
                <li>Use Enterprise Manager (EM) </li>
                <li>Access a database with SQL*Plus and iSQL*Plus </li>
                <li>Modify database initialization parameters </li>
                <li>Understand the stages of database startup </li>
                <li>View the Alert log </li>
                <li>Use the Data Dictionary</li>
            </ul>
            <h4>
            Managing Database Storage Structures
            </h4>
            <ul>
                <li> Describe table data storage (in blocks)</li>
                <li>Define the purpose of tablespaces and data files </li>
                <li>Understand and utilize Oracle Managed Files (OMF) </li>
                <li>Create and manage tablespaces </li>
                <li>Obtain tablespace information </li>
                <li> Describe the main concepts and functionality of Automatic Storage Management (ASM)</li>
            </ul>

            <h4>
            Administering User Security
            </h4>
            <ul>
                <li>Create and manage database user accounts </li>
                <li> Authenticate users</li>
                <li>Assign default storage areas (tablespaces) </li>
                <li>Grant and revoke privileges </li>
                <li>Create and manage roles </li>
                <li>Create and manage profiles </li>
                <li>Implement standard password security features </li>
                <li>Control resource usage by users </li>
            </ul>
            <h4>
            Managing Schema Objects
            </h4>
            <ul>
                <li>Define schema objects and data types </li>
                <li>Create and modify tables </li>
                <li>Define constraints </li>
                <li>View the columns and contents of a table </li>
                <li>Create indexes, views and sequences </li>
                <li>Explain the use of temporary tables </li>
                <li>Use the Data Dictionary </li>
            </ul>

            <h4>
            Managing Data and Concurrency   
            </h4>
            <ul>
                <li>Manage data through SQL </li>
                <li> Identify and administer PL/SQL Objects</li>
                <li>Describe triggers and triggering events </li>
                <li>Monitor and resolve locking conflicts </li>
            </ul>
            <h4>
            Managing Undo Data
            </h4>
            <ul>
                <li>Explain DML and undo data generation </li>
                <li>Monitor and administer undo </li>
                <li>Describe the difference between undo and redo data </li>
                <li>Configure undo retention </li>
                <li> Guarantee undo retention</li>
                <li> Use the undo advisor</li>
            </ul>

            <h4>
            Implementing Oracle Database Security
            </h4>
            <ul>
                <li>Describe DBA responsibilities for security </li>
                <li>Apply the principal of least privilege </li>
                <li>Enable standard database auditing </li>
                <li>Specify audit options </li>
                <li>Review audit information </li>
                <li>Maintain the audit trail </li>
            </ul>
            <h4>
            Configuring the Oracle Network Environment  
            </h4>
            <ul>
                <li> Use Enterprise Manager for configuring the Oracle network environment</li>
                <li> Create additional listeners</li>
                <li>Create Net Service aliases</li>
                <li>Configure connect-time failover </li>
                <li>Control the Oracle Net Listener </li>
                <li>Test Oracle Net connectivity </li>
                <li>Identify when to use shared versus dedicated servers </li>
            </ul>
            <h4>
            Proactive Maintenance
            </h4>
            <ul>
                <li>Use statistics </li>
                <li> Manage the Automatic Workload Repository (AWR)</li>
                <li>Use the Automatic Database Diagnostic Monitor (ADDM) </li>
                <li>Describe advisory framework </li>
                <li>Set alert thresholds </li>
                <li>Use server-generated alerts </li>
                <li>Use automated tasks </li>
            </ul>
            <h4>
            Performance Management
            </h4>
            <ul>
                <li>Use Enterprise Manager pages to monitor performance </li>
                <li>Use the SQL Tuning Advisor </li>
                <li>Use the SQL Access Advisor </li>
                <li> Use Automatic Shared Memory Management</li>
                <li>Use the Memory Advisor to size memory buffers </li>
                <li>Use performance related dynamic views </li>
                <li> Troubleshoot invalid or unusable objects</li>
            </ul>
            <h4>
            Backup and Recovery Concepts     
            </h4>
            <ul>
                <li>Identify the types of failure that may occur in an Oracle Database </li>
                <li> Describe ways to tune instance recovery</li>
                <li> Identify the importance of checkpoints, redo log files, and archived log files</li>
                <li> Configure ARCHIVELOG mode</li>
            </ul>

            <h4>
            Performing Database Backups
            </h4>
            <ul>
                <li> Create consistent database backups</li>
                <li>Back your database up without shutting it down </li>
                <li>Create incremental backups </li>
                <li>Automate database backups </li>
                <li> Monitor the flash recovery area</li>
            </ul>
            <h4>
            Performing Database Recovery
            </h4>
            <ul>
                <li>Recover from loss of a control file </li>
                <li>Recover from loss of a redo log file </li>
                <li>Perform complete recovery following the loss of a data file </li>
            </ul>
            <h4>
            Performing Flashback
            </h4>
            <ul>
                <li>Describe Flashback database </li>
                <li>Restore the table content to a specific point in the past with Flashback Table </li>
                <li>Recover from a dropped table </li>
                <li>View the contents of the database as of any single point in time with Flashback Query </li>
                <li>See versions of a row over time with Flashback Versions Query </li>
                <li>View the transaction history of a row with Flashback Transaction Query </li>
            </ul>
            <h4>
            Moving Data
            </h4>
            <ul>
                <li> Describe available ways for moving data</li>
                <li> Create and use directory objects</li>
                <li>Use SQL*Loader to load data from a non-Oracle database (or user files) </li>
                <li>Explain the general architecture of Data Pump </li>
                <li> Use Data Pump Export and Import to move data between Oracle databases</li>
                <li> Use external tables to move data via platform-independent files</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OracleDBA_L1;
